import Loading from "../../../components/Loading"
import ProjectGrid from "../../../components/ProjectGrid"

const RetailListComponent = ({ RetailList }: any) => (
  <div className="pt-5 pb-5">
    {RetailList?.length > 0 ? (
      <>
        <h2 className="fs-1 fw-bolder text-uppercase">Key Commercial Lots</h2>
        <p className="w-50 fs-4">
          From commercial spaces to commercial lots, ranging from big to small,
          there's a PRIME property that can accommodate new and existing
          businesses.
        </p>
        <ProjectGrid
          object={RetailList}
          link="/find-a-property/search?type=Commercial+Lots"
          linkText="VIEW OTHER COMMERCIAL LOTS"
        />
      </>
    ) : (
      <Loading />
    )}
  </div>
);

export default RetailListComponent;